/** 
 * This module is a common place to keep application specific error classes. 
 * It is expected that the classes here will extend built-in Error class 
 * and would include kind of Operational errors.
*/

export class HTTPError extends Error {  
    constructor(status, statusText, errorData={}) {
      super(`HTTPError ${status}: ${statusText}`);
      this.status = status;
      this.statusText = statusText;
      this.errorData = errorData;
    }
}
  
export class TransactionActionError extends Error {
    constructor(status, statusText, errorData) {
        super(`TransactionActionError ${status}: ${statusText}`);
        this.status = status;
        this.statusText = statusText;
        this.errorData = errorData;
    }
}

export class RestClientInvocationError extends Error {
    constructor(errorMessage) {
        super(errorMessage);
    }
}
